// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5g-6";
export var headerCell = "_5g-2";
export var loadingStateContent = "_5g-8";
export var rowWrapper = "_5g-4";
export var stickyAggregationCell = "_5g-b";
export var stickyAggregationRow = "_5g-7";
export var stickyColumnCell = "_5g-a";
export var stickyColumnHeaderCell = "_5g-9";
export var table = "_5g-1";
export var virtualRowWrapper = "_5g-5";
export var virtualTableContainer = "_5g-0";
export var white = "_5g-3";